import queryString from 'query-string';
import type { Router } from '@funtech-int/rival';

type PlusPaymentPage =
    | 'Settings'
    | 'SelectionScreen'
    | 'MovieCard'
    | 'MyMoviesScreen'
    | 'MyPage'
    | 'WatchingHistoryScreen'
    | 'Communications'
    | 'ChannelPage'
    | 'PersonPage'
    | 'Music'
    | 'YasminaPage'
    | 'CrunchyrollPage'
    | 'AdminFamilyAdd'
    | 'Profiles'
    | 'Purchases'
    | 'Player'
    | 'ShowcaseScreen'
    | 'Sport';

export interface RouteMeta {
    plusPaymentPage?: PlusPaymentPage;
    page: string;
}

interface RemoveQueryParamsFromUrlProps {
    router: Router;
    queryParams: string[];
}

export const removeQueryParamsFromUrl = ({
    router,
    queryParams,
}: RemoveQueryParamsFromUrlProps): boolean => {
    const browserSearch = window.location.search;

    if (!browserSearch) {
        return true;
    }

    const parsedQueryString = queryString.parse(browserSearch);

    queryParams.forEach((param) => delete parsedQueryString[param]);

    const stringifiedQueryString = queryString.stringify(parsedQueryString);

    try {
        const searchParams = stringifiedQueryString
            ? new URLSearchParams(stringifiedQueryString)
            : undefined;

        router.navigate({
            to: router.location,
            replace: true,
            meta: searchParams ? { searchParams } : undefined,
        });

        return true;
    } catch (error) {
        return false;
    }
};
